export default __webpack_public_path__ + "static/media/358.f6298e7e.png";